import { EVENT_NAMES, TEST_EVENT_NAMES } from './constants';
import { nr } from '../newRelic';
import { SSR } from '../utilities';

export function track(
  event: string,
  properties?: Object,
  options?: SegmentAnalytics.SegmentOpts,
  callback?: () => void,
): void {
  try {
    if (SSR) return;

    window.analytics.track(
      event,
      properties,
      {
        ...options,
        integrations: {
          ...options?.integrations,
          ...getFacebookPixelSetting(event),
        },
      },
      callback,
    );
  } catch (e) {
    console.error(e);
    nr.noticeError(e instanceof Error ? e : `${e}`);
  }
}

/***
 * For legal reasons, we need to tightly control what events are sent to Meta
 */
const allowedEventsForFacebookPixel: string[] = [
  EVENT_NAMES.GATSBY_PAGEVIEW, // in Segment, mapped to: 'View Content'
  EVENT_NAMES.LEAD_CAPTURED, // in Segment, mapped to: 'Lead'
  EVENT_NAMES.SIGNED_UP, // in Segment, mapped to: 'Complete Registration'
  EVENT_NAMES.ORDER_COMPLETED, // in Segment, mapped to: 'Purchase'

  // Events used in development and testing
  TEST_EVENT_NAMES.SIGNED_UP,
  TEST_EVENT_NAMES.ORDER_COMPLETED,
];
function getFacebookPixelSetting(event: string) {
  return { 'Facebook Pixel': allowedEventsForFacebookPixel.includes(event) };
}
